import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';

export const searchApi = (query, serviceIds, lang) =>
  post('/service/lineout/frontend_api/search/', {
    query,
    service_id: serviceIds,
    lang
  }).then(camelizeKeys);
